<template>
  <nav class="navbar navbar-public navbar-reverse navbar-expand-lg">
    <div class="container">
      <router-link
        to="/"
        class="navbar-brand smooth"
      >
        SiPeDuLi Jembrana
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fas fa-bars" />
      </button>

      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto ml-lg-3 align-items-lg-center">
          <li class="nav-item">
            <router-link
              to="/layanan"
              class="nav-link"
            >
              Layanan
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/berita"
              class="nav-link"
            >
              Berita
            </router-link>
          </li>
          <li class="nav-item">
            <a
              href="/login"
              class="nav-link"
            >Login</a>
          </li>
          <li class="nav-item">
            <a
              href="/register"
              class="nav-link"
            >Register</a>
          </li>
          <li class="nav-item">
            <a
              href="#"
              class="nav-link"
              @click="$bvModal.show('modal-lihat-kontak')"
            >Kontak</a>
          </li>
          <li class="nav-item d-lg-none d-md-block">
            <a
              href="https://play.google.com/store/apps/details?id=com.laksita.dukcapil_jembrana"
              class="nav-link smooth"
              target="_blank"
            >Download App</a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto align-items-lg-center d-none d-lg-block">
          <li class="ml-lg-3 nav-item">
            <a
              href="https://play.google.com/store/apps/details?id=com.laksita.dukcapil_jembrana"
              class="btn btn-round smooth btn-icon icon-left"
              target="_blank"
            >
              <i class="fas fa-download" /> Download
            </a>
          </li>
        </ul>
      </div>
    </div>
    <b-modal
      id="modal-lihat-kontak"
      title="Kontak"
      hide-footer
    >
      <div
        v-if="pageKontakShow"
        v-html="pageKontakShow.konten_page"
      />
      <div class="text-right mt-4">
        <button
          class="btn btn-secondary"
          @click="$bvModal.hide('modal-lihat-kontak')"
        >
          <i class="fa fa-times mr-2" />Tutup
        </button>
      </div>
    </b-modal>
  </nav>
</template>

<style scoped>

.navbar.navbar-public {
  position: relative;
  left: 0;
}
.navbar .navbar-nav .btn {
    background-color: #fff;
    border-color: #fff;
    color: #000;
    line-height: 25px;
    padding: 7px 25px;
}
.navbar .navbar-nav .nav-link, .navbar .navbar-nav .dropdown-item, .navbar .navbar-nav .dropdown-title, .navbar .navbar-nav .btn {
    font-weight: 600;
    font-size: 14px;
}

</style>

<script>

export default {
    data(){
        return {
            
        }
    },
    computed: {
        pageKontakShow(){
            return this.$store.getters.getPageShow
        }
    },
    created(){
        this.$store.dispatch('showPage', 'kontak').then(res => {
            if(res.data.status){
                this.$store.dispatch('setPageShow', res.data.data)
            }
        })
    }
}
</script>